const optionsStrainUnits = [{
  label: '‰',
  value: 'perThousand'
}, {
  label: '%',
  value: 'perCent'
}];

export default optionsStrainUnits;
